import {
  CreateGUFClosureRealisedPartTask,
  EditGUFClosureRealisedPartTask,
  QualityRegimeOptions,
} from "@nens/brostar/uploadapi-client";

import { BrostarUiSchema } from "@/libs/brostar-form";

import { createGufUiSchemaLibrary } from "./guf-ui-schema-library";

export function useGufClosureRealisedPartUiSchema(
  qualityRegimeValue: QualityRegimeOptions | undefined
): BrostarUiSchema<CreateGUFClosureRealisedPartTask | EditGUFClosureRealisedPartTask> {
  const {
    projectNumber,
    qualityRegime,
    deliveryAccountableParty,
    broId,
    correctionReason,
    realisedInstallationId,
    installationFunction,
    wellPos,
    endTime,
    realisedWellId,
  } = createGufUiSchemaLibrary(qualityRegimeValue);

  const uiSchema: BrostarUiSchema<
    CreateGUFClosureRealisedPartTask | EditGUFClosureRealisedPartTask
  > = {
    "ui:order": ["metadata", "sourcedocumentData"],
    metadata: {
      "ui:title": "Metadata",
      projectNumber,
      qualityRegime,
      deliveryAccountableParty,
      broId,
      correctionReason,
    },
    sourcedocumentData: {
      "ui:title": "Brondocumentgegevens",
      "ui:order": [
        "realisedInstallationId",
        "installationFunction",
        "wellPos",
        "endTime",
        "realisedWells",
      ],
      realisedInstallationId,
      installationFunction,
      wellPos,
      endTime,
      realisedWells: {
        "ui:options": { labelField: "realisedWellId" },
        items: {
          "ui:order": ["realisedWellId"],
          realisedWellId,
        },
      },
    },
  };

  return uiSchema;
}
